'use client';

import type { ReservationStepProps } from '../reservation-form';

import { ReservationCalendar } from '../reservation-calendar/reservation-calendar';

export function ChooseDate({ form, services, selectedPerson }: ReservationStepProps) {
  const selectedServiceId = form.watch('reservation_service');

  return (
    <div className="w-full">
      <ReservationCalendar
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        selectedPerson={selectedPerson}
      />
    </div>
  );
}
